var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8 4H3.2C2.5 4 2 4.5 2 5.2v1.1l9.4 5.5c.4.2.8.2 1.2 0L22 6.2v-1c0-.7-.5-1.2-1.2-1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.7c-.4 0-.7-.1-1-.3L2 8.2v10.7c0 .6.5 1.1 1.2 1.1h17.6c.7 0 1.2-.5 1.2-1.2V8.2l-9 5.3c-.3.1-.6.2-1 .2z"
  })));
}

export default SvgEnvelope;